module.exports = __webpack_public_path__ + "img/login-lock-right.213e55d8.svg";